import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import PropTypes from "prop-types";
import ServerFormErrors from "../../util/ServerFormErrors";
import ax from "../../util/axios";
import { useIntl } from "react-intl";

const AddEventForm = (props) => {
  const intl = useIntl();
  const [errorMessage, setErrorMessages] = useState();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    ax({
      method: "POST",
      url: props.url,
      data: { form: data },
    })
      .then(function () {
        window.location = window.location.href;
      })
      .catch((err) => {
        setErrorMessages(err.response.data);
      });
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <label>{intl.formatMessage({ id: `admin-area.scenarios.add-event.select-${props.eventType}` })}</label>
          <select className="form-control" {...register("event_id", { required: true })}>
            <option key="0" value="">
              {intl.formatMessage({ id: "shared.dropdown.please-select" })}
            </option>
            {props.events.map((event) => {
              return (
                <option key={event.id} value={event.id}>
                  {`${event.title} (${event.event_id})`}
                </option>
              );
            })}
          </select>
          {errors.event_id?.type === "required" && (
            <div className="field-error">{intl.formatMessage({ id: "shared.forms.required" })}</div>
          )}
        </div>

        <div className="btn-group btn-end ">
          <button type="submit" className="btn btn-primary small angled-bottom-right">
            {intl.formatMessage({ id: "shared.forms.save" })}
          </button>
        </div>
      </form>

      <ServerFormErrors errorMessages={errorMessage}></ServerFormErrors>
    </div>
  );
};

AddEventForm.propTypes = {
  url: PropTypes.string.isRequired,
  events: PropTypes.array.isRequired,
  eventType: PropTypes.string.isRequired,
};

AddEventForm.defaultProps = {
  eventType: "micro-event",
};

export default AddEventForm;
